import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Button } from './ui/button';
import { mockData } from '../data/mock';

const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === mockData.testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === 0 ? mockData.testimonials.length - 1 : prev - 1
    );
  };

  const testimonial = mockData.testimonials[currentTestimonial];

  return (
    <section className="py-20 bg-stone-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6 title-font">
            Testimonials
          </h2>
        </div>

        {/* Testimonial Content */}
        <div className="relative">
          <div className="text-center">
            {/* Quote Icon */}
            <div className="mb-8">
              <Quote className="w-12 h-12 text-[#81be00] mx-auto" />
            </div>

            {/* Quote Text */}
            <blockquote className="text-xl md:text-2xl text-stone-700 leading-relaxed mb-12 italic">
              "{testimonial.quote}"
            </blockquote>

            {/* Author Info */}
            <div className="flex flex-col items-center">
              <div className="w-20 h-20 overflow-hidden mb-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <h4 className="text-xl font-medium text-stone-800 mb-1 title-font">
                {testimonial.name}
              </h4>
              
              <p className="text-stone-600 text-sm uppercase tracking-wide">
                {testimonial.role}
              </p>
            </div>
          </div>

          {/* Navigation Arrows */}
          <div className="absolute top-1/2 left-0 right-0 flex justify-between pointer-events-none">
            <Button
              variant="ghost"
              size="sm"
              onClick={prevTestimonial}
              className="pointer-events-auto -translate-y-1/2 w-12 h-12 bg-white shadow-lg hover:bg-stone-50 text-stone-600 hover:text-stone-800"
            >
              <ChevronLeft size={20} />
            </Button>
            
            <Button
              variant="ghost"
              size="sm"
              onClick={nextTestimonial}
              className="pointer-events-auto -translate-y-1/2 w-12 h-12 bg-white shadow-lg hover:bg-stone-50 text-stone-600 hover:text-stone-800"
            >
              <ChevronRight size={20} />
            </Button>
          </div>
        </div>

        {/* Dots Indicator */}
        <div className="flex justify-center mt-12 space-x-2">
          {mockData.testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentTestimonial(index)}
              className={`w-3 h-3 transition-all duration-300 ${
                index === currentTestimonial 
                  ? 'bg-[#81be00]' 
                  : 'bg-stone-300 hover:bg-stone-400'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;